import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import StorageService from "../../services/StorageService";
import { localstorageKeys } from "@const/store";
import { toggleSignUpModal } from "@redux/signUp/actions";
import routes from "../../const/routes";

const ReferralHandler = () => {
  const { search, pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { accessToken } = StorageService.get(localstorageKeys.session, {});
  const referralCode = new URLSearchParams(search).get("ref");
  const contentOwnerKeyFromUrl = new URLSearchParams(search).get(
    "contentOwnerKey",
  );

  useEffect(() => {
    const contentOwnerKey = pathname.includes("u")
      ? pathname.replace("/u/", "")
      : contentOwnerKeyFromUrl;
    if (!referralCode) return;
    StorageService.set(localstorageKeys.referral, {
      contentOwnerKey,
      referralCode,
    });
  }, [referralCode]);

  useEffect(() => {
    if (!pathname.includes("creators")) return;
    StorageService.set(localstorageKeys.creatorReferral, {
      newCreatorReferralCode:
        pathname.split("/")[pathname.split("/").length - 1],
    });
    navigate(accessToken ? `${routes.FEED()}#posts` : "/", { replace: true });
    if (!accessToken) dispatch(toggleSignUpModal(true));
  }, []);

  return null;
};

export default ReferralHandler;
